import { render, staticRenderFns } from "./home.vue?vue&type=template&id=a35f2dc6&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=a35f2dc6&prod&lang=scss"
import style1 from "./home.vue?vue&type=style&index=1&id=a35f2dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35f2dc6",
  null
  
)

export default component.exports